import Router from "next/router"

export const MARKETPLACE_ORDERS_PATH = "/drops?open=orders"
export const MARKETPLACE_CART_PATH = "/drops?open=cart"

export function goToMarketplaceOrders() {
	void Router.push(MARKETPLACE_ORDERS_PATH)
}

export function goToMarketplaceCart() {
	void Router.push(MARKETPLACE_CART_PATH)
}
